import { render, staticRenderFns } from "./asset-summary.vue?vue&type=template&id=4d2aac52&scoped=true"
import script from "./asset-summary.vue?vue&type=script&lang=ts"
export * from "./asset-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2aac52",
  null
  
)

export default component.exports